export const RightSidebarExpand: React.FC = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_424_6387)">
      <mask id="mask0_424_6387" maskUnits="userSpaceOnUse" x="0" y="0"
        width="20" height="21">
        <path d="M0 0.446045H20V20.8348H0V0.446045Z" fill="white" />
      </mask>
      <g mask="url(#mask0_424_6387)">
        <path
          d="M5.98875 18.9233V2.35742M16.805 18.9233H3.195C2.67875 18.9233 2.18375 18.7296 1.82 18.3842C1.64189 18.2191 1.49928 18.0181 1.40117 17.7939C1.30307 17.5698 1.2516 17.3274 1.25 17.0819V4.19878C1.25 3.18189 2.12 2.35742 3.195 2.35742H16.805C17.88 2.35742 18.75 3.18189 18.75 4.19878V17.0819C18.75 18.0988 17.8788 18.9233 16.805 18.9233Z"
          stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.0213 10.1536C9.97479 10.2009 9.93791 10.2572 9.91275 10.319C9.88759 10.3809 9.87463 10.4472 9.87463 10.5142C9.87463 10.5812 9.88759 10.6475 9.91275 10.7094C9.93791 10.7713 9.97479 10.8275 10.0213 10.8749L13.0213 13.9332C13.0912 14.0045 13.1803 14.0531 13.2774 14.0728C13.3744 14.0925 13.475 14.0824 13.5664 14.0438C13.6578 14.0052 13.736 13.9398 13.7909 13.8559C13.8458 13.772 13.8751 13.6734 13.875 13.5725V7.45592C13.8751 7.35505 13.8458 7.25642 13.7909 7.17253C13.736 7.08863 13.6578 7.02324 13.5664 6.98462C13.475 6.94601 13.3744 6.93592 13.2774 6.95562C13.1803 6.97532 13.0912 7.02393 13.0213 7.09529L10.0213 10.1536Z"
          fill="currentColor" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_424_6387">
        <rect width="20" height="20.3887" fill="white" transform="translate(0 0.446045)" />
      </clipPath>
    </defs>
  </svg>
)